import axios from 'axios';

const api = () => `${process.env.REACT_APP_BACKEND_URL}/api`;
const base = () => `${api()}/worship/setlist-library`;

export const listLibrary = (params, { signal } = {}) => axios.get(base(), { params, signal }).then((response) => response.data);

export const getLibrarySetlist = (id) => axios.get(`${base()}/${encodeURIComponent(id)}`).then((response) => response.data);

export const previewImport = (servicesFile, linesFile) => {
  const form = new FormData();
  form.append('services_file', servicesFile);
  form.append('lines_file', linesFile);
  return axios.post(`${base()}/import/preview`, form).then((response) => response.data);
};

export const confirmImport = (batchId, decisions) => axios
  .post(`${base()}/import/${encodeURIComponent(batchId)}/confirm`, decisions)
  .then((response) => response.data);

export const setLibraryStatus = (id, status) => axios
  .put(`${base()}/${encodeURIComponent(id)}/status`, { status })
  .then((response) => response.data);

export const detachVersion = (id) => axios.post(`${base()}/${encodeURIComponent(id)}/detach`).then((response) => response.data);

// songId = null removes the link; the original title of the historical line always stays.
export const setItemLink = (id, itemId, songId) => axios
  .put(`${base()}/${encodeURIComponent(id)}/items/${encodeURIComponent(itemId)}/link`, { song_id: songId })
  .then((response) => response.data);

export const listTargetServices = () => axios.get(`${base()}/target-services`).then((response) => response.data);

export const reuseSetlist = (id, payload) => axios.post(`${base()}/${encodeURIComponent(id)}/reuse`, payload).then((response) => response.data);

// A new planned service goes through the existing planning endpoint; the library never creates services itself.
export const createService = (payload) => axios.post(`${api()}/worship/services`, payload).then((response) => response.data);

export const errorMessage = (error, fallback) => {
  const detail = error?.response?.data?.detail;
  if (typeof detail === 'string') return detail;
  if (detail?.errors?.length) return detail.errors.join(' ');
  if (detail?.message) return detail.message;
  return fallback;
};
